import ErrorHandler from './ErrorHandler';

export function fetchLocations(id) {
  return fetch(`/api/products/${id}/locations`, { method: 'GET' })
    .then(ErrorHandler)
    .then((response) => response.json());
}
